import { connect } from 'react-redux';
import PengajuanIjinPulang from '../../../views/Personnel/Absensi/PengajuanIjinPulang.absensi.view';
import { getAssignment } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAssignment: payload => dispatch(getAssignment(payload)),
  };
}

export default connect(null, mapDispatchToProps)(PengajuanIjinPulang);